import React, { useContext, useEffect, useState } from "react";
import "./style.scss";
import SearchIcon from "../../../assets/CreateCategory/SeachIcon.svg";
import {
  useAddSubCategoryToMarketPlace,
  useGetAllSubCategorises,
} from "../../../hooks/useGuidelines";
import { Empty, message, Modal } from "antd";
import CreateSubCategory from "../CreateSubCategory";
import DebounceInput from "../../../common/DebounceInput";
import { GuidelinesSelectedCategoryContext } from "../../../context/guidelinesProvider";

const AddSubCategory = ({
  setIsCreateSubCategory,
  isCreateSubCategory,
  setIsAddSubCategory,
  activeCategoryItem,
  activeSubCategoryItem,
  setActiveSubCategoryItem,
  guide_selectedCategoryId,
  guide_selectedMarketPlaceId,
  isSubCategoryAdded,
  marketPlaceSubCategoryList,
}) => {
  const [search, setSearch] = useState("");
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [pageNum, setPageNum] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [enabled, setEnabled] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [activeSubCategoryName, setActiveSubCategoryName] = useState("");
  const { guide_setSelectedSubCategoryId, guide_setSelectedSubCategoryName } =
    useContext(GuidelinesSelectedCategoryContext);
  const onSuccessGetAllSubCategories = (data) => {
    if (data?.status == 200) {
      setSubCategoryList(data?.data?.data);
    }
  };

  const onErrorGetAllSubCategories = (err) => {
    console.log(err.message);
  };

  const { data: getAllSubCategories, refetch: refetchSubCategories } =
    useGetAllSubCategorises(
      "getAllSubCategories",
      guide_selectedCategoryId,
      pageNum,
      pageSize,
      search,
      onSuccessGetAllSubCategories,
      onErrorGetAllSubCategories
    );

  const onSuccessAddSubCategory = (res, payload) => {
    if (res.status == 200) {
      message.success("Sub category successfully added");
      guide_setSelectedSubCategoryId(payload?.subCategory);
      guide_setSelectedSubCategoryName(activeSubCategoryName);

      setTimeout(() => {
        isSubCategoryAdded();
      });
    }
  };

  const onErrorAddSubCategory = () => {};

  const { mutate: getAddSubCategory } = useAddSubCategoryToMarketPlace(
    onSuccessAddSubCategory,
    onErrorAddSubCategory
  );

  const addSubCategoryHandler = () => {
    let payload = {
      subCategory: activeSubCategoryItem,
      category: guide_selectedCategoryId,
      marketplace: guide_selectedMarketPlaceId,
    };
    getAddSubCategory(payload);
  };

  useEffect(() => {
    if (subCategoryList.length > 0) {
      const initialCategory = subCategoryList[0];
      setActiveSubCategoryItem(initialCategory._id);
    }
  }, [subCategoryList]);

  const subCategoryCreated = () => {
    setIsCreateSubCategory(false);
    refetchSubCategories();
    setEnabled(false);
  };

  const handleSubCategoryCreated = (categoryName) => {
    setSelectedCategory(categoryName);
    sessionStorage.setItem("subCategory Created", categoryName);
  };

  const getCreateSubCategoryModal = () => {
    return (
      <Modal
        title="Create Sub Category"
        open={isCreateSubCategory}
        footer={null}
        width="60%"
        height="90dvh"
        className="create_subcategory_modal_wrapper"
        onCancel={() => setIsCreateSubCategory(false)}
      >
        <CreateSubCategory
          isSubCategoryCreated={subCategoryCreated}
          handleModalClose={() => setIsCreateSubCategory(false)}
          onSubCategoryCreated={handleSubCategoryCreated}
        />
      </Modal>
    );
  };

  return (
    <div className="add_sub_category_main_wrapper">
      <div className="action_wrapper">
        <div className="search_wrapper">
          <DebounceInput
            searchName={search}
            setSearchName={setSearch}
            placeholder={"Search"}
            allowClear={true}
            showSearch={true}
          />
          {/* <input
            className="searchInput"
            placeholder="Search"
            name="search"
            value={search}
            onChange={handleSearch}
          /> */}
          <div className="searchIcon_wrapper">
            <img src={SearchIcon} alt="searchIcon" />
          </div>
        </div>
        <div className="action_btn">
          <button
            onClick={() => setIsCreateSubCategory(true)}
            className="createBtn"
          >
            {" "}
            Create Sub Category
          </button>
          <button
            className="add_btn"
            disabled={subCategoryList?.length === 0}
            onClick={() => addSubCategoryHandler()}
          >
            Add
          </button>
        </div>
      </div>
      {subCategoryList?.length > 0 ? (
        <div className="category_list">
          {subCategoryList
            ?.filter((data) => {
              return search?.toLowerCase() === ""
                ? data
                : data?.name?.toLowerCase()?.includes(search?.toLowerCase());
            })
            .map((category) => {
              const isDisabled = marketPlaceSubCategoryList
                .map((item) => item._id)
                .includes(category._id);
              return (
                <div className={`box ${isDisabled ? "disabled" : ""}`}>
                  <div
                    className={`image_wrapper ${
                      activeSubCategoryItem === category?._id && !isDisabled
                        ? "active"
                        : sessionStorage.getItem("subCategory Created") ===
                          category?.name
                        ? "active"
                        : ""
                    }`}
                    onClick={() => {
                      setActiveSubCategoryItem(category?._id);
                      setActiveSubCategoryName(category?.name);
                    }}
                  >
                    <img
                      src={category?.image?.thumbPath?.url}
                      alt={category?.name}
                    />
                  </div>
                  <span>{category?.name}</span>
                </div>
              );
            })}
        </div>
      ) : (
        <div className="empty_wrapper">
          <Empty description="Create a new Sub Category" />
        </div>
      )}
      {isCreateSubCategory && getCreateSubCategoryModal()}
    </div>
  );
};
export default AddSubCategory;
